import { render } from "./PaymentMethodDisplay.vue?vue&type=template&id=588e34dd&scoped=true&ts=true"
import script from "./PaymentMethodDisplay.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodDisplay.vue?vue&type=script&lang=ts"

import "./PaymentMethodDisplay.vue?vue&type=style&index=0&id=588e34dd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588e34dd"]])

export default __exports__